<template>
    <table class="w-full mx--auto">
        <thead
            class="text-xl border-t border-b-2 text-output-primary border-output-primary "
        >
            <tr>
                <th
                    v-for="(header, index) in tables.headers"
                    :key="index"
                    class="p-3 "
                >
                    {{ header.title }}
                </th>
            </tr>
        </thead>
        <tbody class="text-lg text-output-primary">
            <tr
                v-for="(tableData, tableIndex) in tables.data"
                :key="tableIndex"
                :class="[
                    ' border-output-primary',
                    {
                        'border-b': tables.data.length !== tableIndex + 1,
                        ' border-b-2': tables.data.length === tableIndex + 1
                    }
                ]"
            >
                <td
                    :colspan="colSpanLength(tableData.length)"
                    v-for="(cellData, cellIndex) in tableData"
                    :key="cellIndex"
                    :class="[
                        ' font-semibold text-center',
                        {
                            'p-3': !isCpc,
                            'p-2': isCpc
                        }
                    ]"
                >
                    {{ cellContent(cellData, cellIndex) }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { formatPrice } from "@/utils";

export default {
    props: {
        tables: {
            type: Object,
            required: true
        },
        isCpc: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        cellContent() {
            return (cellContent, index) => {
                const ContentType = this.tables.headers[index].type;
                if (ContentType !== "String") {
                    switch (ContentType) {
                        case "Currency":
                            return formatPrice(cellContent);
                    }
                }
                return cellContent;
            };
        }
    },
    methods: {
        colSpanLength(tableDataLength) {
            return Math.round(this.tables.headers.length / tableDataLength);
        }
    }
};
</script>

<style></style>
